import React, { useId } from 'react';
import styled from 'styled-components';
import { StatusHelpIcon } from '.';
import Tooltip, { TooltipPosition } from 'components/controls/Tooltip';

const TooltipHelpIcon: React.FunctionComponent<{
  content: string;
  position?: TooltipPosition;
}> = ({ content, position }) => {
  const id = useId();
  const paragraphs = content.split('\n');
  return (
    <>
      <StatusHelpIcon id={id} />
      <Tooltip targetId={id} position={position ?? 'bottom'} offset={4}>
        {paragraphs.length > 1 ? (
          <Paragraphs>
            {paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </Paragraphs>
        ) : (
          content
        )}
      </Tooltip>
    </>
  );
};

export default TooltipHelpIcon;

/** A multi-line text is shown as paragraphs, one per line, with a small gap between them. */
const Paragraphs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  & p {
    margin: 0;
  }
`;
